import { render, staticRenderFns } from "./MItems.vue?vue&type=template&id=5f0c3560&"
import script from "./MItems.vue?vue&type=script&lang=js&"
export * from "./MItems.vue?vue&type=script&lang=js&"
import style0 from "./MItems.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports